export var selectGrantRewardsInfo = function (state) {
    return state.grantRewards.rewards;
};



//////////////////
// WEBPACK FOOTER
// ./src/selectors/selectGrantRewardsInfo.ts
// module id = 832
// module chunks = 3